import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { esignSelectors } from 'src/app/root-store/esign-store';
import { TemplateSearchParameters } from '../models/template-search-parameters.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'nova-search-template',
    templateUrl: './search-template.component.html',
    styleUrls: ['./search-template.component.scss']
})
export class SearchTemplateComponent implements OnInit, OnDestroy {
    @Output() searchTemplates = new EventEmitter<TemplateSearchParameters>();

    searchControl = new UntypedFormControl('');
    searchAllFolders = new UntypedFormControl(true);
    selectedFolderId: string;
    isLoading: boolean;

    private readonly _cleanup$ = new Subject();

    constructor(private readonly _store: Store<{}>) {}

    ngOnInit(): void {
        this._store
            .select<string>(esignSelectors.selectSelectedFolder)
            .pipe(untilDestroyed(this))
            .subscribe((folderId) => {
                this.selectedFolderId = folderId;
            });

        this._store
            .select<boolean>(esignSelectors.selectTemplateSearchComplete)
            .pipe(untilDestroyed(this))
            .subscribe((isComplete) => {
                this.isLoading = isComplete;
            });
    }

    ngOnDestroy(): void {
        this._cleanup$.next(true);
        this._cleanup$.complete();
    }

    search(): void {
        const params: TemplateSearchParameters = {
            searchText: this.searchControl.value,
            searchAllFolders: this.searchAllFolders.value
        };
        this.searchTemplates.emit(params);
    }
}
